import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-text-btn',
  templateUrl: './text-btn.component.html',
  styleUrls: ['./text-btn.component.css']
})
export class TextBtnComponent implements OnInit {

  @Output() callOnClick: EventEmitter<string> = new EventEmitter();
  @Input() btnLabel: string;
  @Input() routingUrl: string;

  constructor() { }

  ngOnInit() {
  }

  onBtnClick(): void {
    // alert('clicked cancel in child component');
    this.callOnClick.emit();
  }

}
